import { API } from "../utils";

export const getChatRooms = async ({ params } = {}) => {
  return await API.get("/organization/chats", { params });
};

export const getChatMessages = async ({ params }) => {
  return await API.get(`/organization/chats/${params.id}/messages`, { params });
};

export const sendMessage = async ({ body }) => {
  const formData = new FormData();
  if (body.chat_room_id) formData.append("chat_room_id", body.chat_room_id);
  if (body.message) formData.append("message", body.message);
  if (body.reply_to_id) formData.append("reply_to_id", body.reply_to_id);
  /* A shared panel object travels as a type plus an id; the API resolves the
     title at read time so a renamed task is not stale in an old thread. */
  if (body.entity_type && body.entity_id) {
    formData.append("entity_type", body.entity_type);
    formData.append("entity_id", body.entity_id);
  }
  if (body.attachments?.length) {
    body.attachments.forEach((file, i) =>
      formData.append(`attachments[${i}]`, file),
    );
  }
  return await API.post("/organization/chats/send", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const createChatRoom = async ({ body }) => {
  return await API.post("/organization/chats", body);
};

export const updateChatRoom = async ({ params, body = {} }) => {
  const formData = new FormData();
  if (body.title != null) formData.append("title", body.title);
  if (Array.isArray(body.participants)) {
    body.participants.forEach((id) => formData.append("participants[]", id));
  }

  if (body.avatar) formData.append("avatar", body.avatar);
  return await API.patch(`/organization/chats/${params.id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadChatMedia = async ({ params, body, onUploadProgress }) => {
  return await API.post(`/organization/chats/${params.chat}/media`, body, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
    timeout: 120000,
  });
};

export const deleteChatMedia = async ({ params }) => {
  return await API.delete(
    `/organization/chats/${params.chat}/media/${params.media}`,
  );
};

export const deleteMessage = async ({ params }) => {
  return await API.delete(
    `/organization/chats/${params.chatId}/message/${params.messageId}`,
  );
};
